import request from './request'

// 获取热门搜索
export function _hotSeachIndex(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/hot-search/index',
    })
    return request(config)
}

//保存热门搜索
export function _hotSeachSave(data = {}) {
    const config = Object.assign(data, {
      method: 'post',
      url: '/admin/hot-search/save',
    })
    return request(config)
}

//banner列表
export function _bannerList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/banner/index',
  })
  return request(config)
}

//提交banner信息
export function _bannerSave(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/banner/edit',
  })
  return request(config)
}

//banner排序
export function _bannerSort(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/banner/sort',
  })
  return request(config)
}

//banner删除
export function _bannerDel(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/banner/remove',
  })
  return request(config)
}